import { render, staticRenderFns } from "./GYoutubeForm.vue?vue&type=template&id=1423fa18&scoped=true&"
import script from "./GYoutubeForm.vue?vue&type=script&lang=ts&"
export * from "./GYoutubeForm.vue?vue&type=script&lang=ts&"
import style0 from "./GYoutubeForm.vue?vue&type=style&index=0&id=1423fa18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423fa18",
  null
  
)

export default component.exports